import React from "react";
import { NavigationItem } from "./types";
import { Image } from "@builder.io/react";
import BuilderImage from "../../blocks/image/builder-image";

export type NavItemLabelProps = {
  navItem: NavigationItem;
  width?: string;
  height?: string;
};
export const NavItemLabel: React.FC<NavItemLabelProps> = ({
  navItem,
  width = "16",
  height = "16",
}) => {
  const urlWithParams = `${navItem.icon}?width=${width}&height=${height}`;
  //console.log(urlWithParams, navItem);

  return (
    <div className="flex flex-row content-center items-center">
      {navItem.icon && (
        <div className="w-[32px] h-[16px]">
          <BuilderImage
            className="pr-1 rounded-sm"
            url={navItem.icon}
            alt={navItem.label}
            title={navItem.label}
            lazy={false}
            aspectRatio={"32/16"}
            width="32"
            height="32"
          />
        </div>
      )}
      {!navItem.iconOnly && <div>{navItem.label}</div>}
    </div>
  );
};

export default NavItemLabel;
